'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CounterStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  disabled: _propTypes2.default.bool,
  /**
   * Define component theme config
   * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
   * for more information
   */
  theme: _propTypes2.default.object
};

var defaultProps = {
  disabled: false
};

/** PROP RECEIVERS */
var styleProps = function styleProps(_ref) {
  var themeFromProvider = _ref.theme,
      error = _ref.error,
      focus = _ref.focus,
      disabled = _ref.disabled;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var path = theme.reactackle.components.textfield.symbolCounter.style;

  var source = null;
  if (!disabled) {
    if (error) source = path.error;else if (focus) source = path.focus;else source = path;
  } else {
    source = path.disabled;
  }

  var _source = source,
      fontColor = _source.fontColor;


  return 'color: ' + fontColor + ';';
};

var baseProps = function baseProps(_ref2) {
  var themeFromProvider = _ref2.theme;

  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);

  var _theme$reactackle$com = theme.reactackle.components.textfield.symbolCounter,
      counterSpacing = _theme$reactackle$com.counterSpacing,
      counterMessageSpacing = _theme$reactackle$com.counterMessageSpacing,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight;


  return '\n    margin-top: ' + (0, _reactackleCore.getValueString)(counterSpacing) + ';\n    margin-left: ' + (0, _reactackleCore.getValueString)(counterMessageSpacing) + ';\n    font-size: ' + (0, _reactackleCore.getValueString)(fontSize) + ';\n    line-height: ' + lineHeight + ';\n  ';
};

var animationPulse = (0, _styledComponents.keyframes)(['from{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1);}50%{-webkit-transform:scale3d(1.1,1.1,1.1);transform:scale3d(1.1,1.1,1.1);}100%{-webkit-transform:scale3d(1,1,1);transform:scale3d(1,1,1);}']);

var animation = function animation(_ref3) {
  var error = _ref3.error;
  return error && '\n  animation: ' + animationPulse + ' 200ms;\n  animation-iteration-count: 3;\n';
};

/** STYLES */
var CounterStyled = exports.CounterStyled = _styledComponents2.default.div.withConfig({
  displayName: 'CounterStyled'
})(['text-align:right;user-select:none;', ';', ';', ';'], baseProps, styleProps, animation);

CounterStyled.propTypes = propTypes;
CounterStyled.defaultProps = defaultProps;
CounterStyled.displayName = 'CounterStyled';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-text-field/dist/styles/CounterStyled.js
// module id = 837
// module chunks = 0